<template>
	<v-layout row justify-center>
		<v-flex>
				<v-card-text>
					<v-text-field
						solo
						v-model="ref"
						name="name"
						label="Référence maestro"
						hint="(maestro/suifa)-1234 | 00/00/0000"
						id="id">
					</v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-btn
						class="mr-0"
						:disabled="!matchRegEx"
						@click="submit(); $emit('close')"
						color="primary color--text">
						Envoyer
					</v-btn>
				</v-card-actions>
		</v-flex>
	</v-layout>

</template>

<script>

import { mapGetters } from 'vuex'

export default {
	props: [ 'details' ],
	data () {
		return {
			ref: '',
			maestroRefRegEx: /^((maestro)|(suifa))-[0-9]{1,}$/g,
			refSuifaRegEx: /[0-9]{2}\/[0-9]{2}\/[a-zA-Z0-9]{4}/g
		}
	},
	computed: {
		...mapGetters([
			'user'
		]),
		matchRegEx () {
			if (this.ref.match(this.maestroRefRegEx)) {
				return true
			} else if (this.ref.match(this.refSuifaRegEx)) {
				return true
			}
		}
	},

	methods: {
		submit () {
			this.submitLoading = true

			let data = {
				jd_id: window.appConfig.maestro_wf['check dcp material'].id,
				parameters: {
					'Material ID': this.ref
				}
			}

			this.$ApiMaestro.jobrequest_create(data)
				.then(response => {
					this.submitLoading = false
					this.$emit('maestroFormSent', response)
				})
				.catch(error => {
					console.error(error)
					this.submitLoading = false
					this.$emit('maestroFormErrorSending', error.response)
				})
		}
	},

	mounted () {
		if (this.details.hasOwnProperty('Material ID')) {
			this.ref = this.details['Material ID']
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_check_dcp.vue